<template>
    <div class="submit-success-card">
        <el-card shadow="always">
            <div slot="header" class="clearfix card-title">
                <span>{{ title }}</span>
            </div>
            <div class="register-success-wrap">
                <div class="r-s-main">{{ infos.main }}</div>
                <div class="r-s-tips">
                    <div class="r-s-tips-title">{{ infos.tips.title }}</div>
                    <div class="r-s-tips-wrap">
                        <div class="r-s-tips-item" v-for="(tips, tIndex) in infos.tips.data" :key="tIndex">
                            <div class="r-s-tips-item-msg">{{ tIndex + 1 + '. ' + tips.msg }}</div>
                            <div v-if="tips.children && tips.children.length" class="r-s-tips-item-data">
                                <div v-for="(data, dIndex) in tips.children" :key="dIndex" v-html="data"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <el-button v-waves class="card-btn-got-it" type="primary" @click="toLogin">{{ $t('Button.GotIt') }}</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import waves from '@/directive/waves' // Waves directive
import CHS from '@/lang/zh.js'
import EN from '@/lang/en.js'
import { FormMixin } from '@/mixins'

export default {
    props: {
        title: { type: String, default: '' },
    },
    directives: { waves },
    mixins: [FormMixin],
    name: 'SubmitSuccessCard',
    data() {
        return {
            infos: CHS.SubmitSuccessPageInfo,
        }
    },
    created() {
        this.infos = this.language === 'zh' ? CHS.SubmitSuccessPageInfo : EN.SubmitSuccessPageInfo
    },
    computed: {
        ...mapGetters(['size', 'language']),
    },
    watch: {
        language(language) {
            this.infos = language === 'zh' ? CHS.SubmitSuccessPageInfo : EN.SubmitSuccessPageInfo
        },
    },
}
</script>

<style lang="scss" scoped>
$color-theme: #4da1ff;

.card-title {
    .close-icon:active {
        opacity: 0.5;
    }
}
.card-footer {
    padding-top: 40px;

    .card-btn-back {
        width: 40%;
    }
    .card-btn-login {
        width: 40%;
    }
    .card-btn-got-it {
        width: 60%;
    }
}
.register-success-wrap {
    /*box-sizing: border-box;*/
    padding: 0 30px;
    .r-s-main {
        font-size: 19px;
        color: #000;
        line-height: 1.2;
        margin-bottom: 44px;
        margin-top: 24px;
    }

    .r-s-tips {
        font-size: 14px;

        .r-s-tips-title {
            font-size: 14px;
            color: $color-theme;
            margin-bottom: 10px;
        }
        .r-s-tips-wrap {
            .r-s-tips-item {
                margin-bottom: 14px;
                &:last-child {
                    margin-bottom: 0;
                }
                .r-s-tips-item-data {
                    margin-top: 5px;
                    div {
                        padding-left: 15px;
                        line-height: 1.5;
                        .eyes-on {
                            color: $color-theme;
                        }
                    }
                } // r-s-tips-item-msg
            } // r-s-tips-item
        } // r-s-tips-wrap
    } // r-s-tips
} // register-success-wrap
</style>
